import "../../styles/HomeNew.css";

const ACTIVITIES = [
  {
    title: "Talent Show",
    emoji: "🎤",
    color: "card--purple",
    chipClass: "lchip--purple",
    badge: "Book Your Spot",
    detail: "Deadline is June 6th",
    href: "",
    cta: "Registration to open in April →",
  },
  {
    title: "Fun Games",
    emoji: "🎮",
    color: "card--pink",
    chipClass: "lchip--pink",
    badge: "Join the Event",
    detail: "Early bird offer ends june 1st",
    href: "",
    cta: "Registration to open in April →",
  },
  {
    title: "Volunteer Opportunities",
    emoji: "🙋",
    color: "card--green",
    chipClass: "lchip--green",
    badge: "Help Out",
    detail: "Help us run a smooth event and make a big impact in our community. We have roles for all ages and skill sets, from setup to cleanup and everything in between.",
    href: "https://www.signupgenius.com/go/4090F4EA4A72AA2FB6-63948717-kite#/",
    cta: "Join the Team →",
  },
];

export default function KiteFest() {
  return (
    <div className="pg">

      {/* ── HERO ── */}
      <section className="hero" style={{ minHeight: "50svh" }}>
        <div className="hero__glow hero__glow--1" />
        <div className="hero__glow hero__glow--2" />
        <div className="hero__glow hero__glow--3" />
        <div className="hero__inner" style={{ gridTemplateColumns: "1fr auto" }}>
          <div className="hero__text">
            <p className="hero__kicker">For A Better Tomorrow · Annual Fundraiser</p>
            <h1 className="hero__h1">
              Kite Fest<br />
              <span className="hero__accent">2027</span>
            </h1>
            <p className="hero__sub">
              Our 13th annual fundraising event — benefiting local and global communities.
              Free for all, full of fun, and powered by your generosity.
            </p>
            <div className="hero__pills">
              <span className="pill pill--purple">🗓 July 17, 2027</span>
              <span className="pill pill--pink">⏰ 11 AM – 6 PM CST</span>
              <span className="pill pill--green">🆓 Free Admission</span>
            </div>
            <div className="hero__ctas">
              <a href="#activities" className="cta cta--solid">View Activities</a>
              <a href="#flyer" className="cta cta--ghost">See Flyer ↓</a>
            </div>
          </div>

          {/* Event Details Card */}
          <div className="hero__stats">
            <div className="hstat hstat--purple">
              <span className="hstat__n">14th</span>
              <span className="hstat__l">Annual Event</span>
            </div>
            <div className="hstat hstat--pink">
              <span className="hstat__n">FREE</span>
              <span className="hstat__l">Admission</span>
            </div>
            <div className="hstat hstat--green">
              <span className="hstat__n">7hr</span>
              <span className="hstat__l">11 AM – 6 PM</span>
            </div>
            <div className="hstat hstat--soft">
              <span className="hstat__n" style={{ fontSize: "1rem", lineHeight: 1.3 }}>Grove<br />Elementary</span>
              <span className="hstat__l">Normal, IL</span>
            </div>
          </div>
        </div>
      </section>

      {/* ── EVENT INFO STRIP ── */}
      <section className="local" style={{ maxWidth: "860px", marginInline: "auto", paddingBottom: 0 }}>
        <div style={{ display: "grid", gridTemplateColumns: "repeat(3, 1fr)", gap: "1rem" }}>
          {[
            { label: "When", value: "Saturday, July 17th, 2027 · 11:00 AM – 6:00 PM CST", emoji: "📅", bg: "var(--pu-50)", border: "var(--pu-200)", color: "var(--pu-700)" },
            { label: "Cost", value: "FREE for All", emoji: "🆓", bg: "var(--gn-50)", border: "var(--gn-200)", color: "var(--gn-700)" },
            { label: "Location", value: "Grove Elementary School, Airport Rd, Normal IL 61761", emoji: "📍", bg: "var(--pk-50)", border: "var(--pk-200)", color: "var(--pk-700)" },
          ].map(item => (
            <div key={item.label} className="lcard" style={{ background: item.bg, borderColor: item.border, gap: ".5rem", alignItems: "flex-start" }}>
              <span style={{ fontSize: "1.4rem" }}>{item.emoji}</span>
              <span className="lcard__chip" style={{ fontSize: ".62rem", background: item.border, color: item.color }}>{item.label}</span>
              <p style={{ fontSize: ".85rem", fontWeight: 600, color: "var(--ink)", lineHeight: 1.5 }}>{item.value}</p>
            </div>
          ))}
        </div>
      </section>

      {/* ── ABOUT ── */}
      <section className="local" style={{ maxWidth: "860px", marginInline: "auto", paddingTop: "1.5rem" }}>
        <div className="lcard lcard--open" style={{ background: "var(--pu-50)", borderColor: "var(--pu-200)", padding: "1.8rem 2rem" }}>
          <p style={{ fontSize: ".97rem", color: "var(--muted)", lineHeight: 1.85, textAlign: "center", fontStyle: "italic" }}>
            For a Better Tomorrow presents Kite Fest, an annual fundraising event benefiting local and global
            communities. This will be our <strong style={{ color: "var(--pu-700)" }}>14th year in a row</strong> since
            starting in 2014. Kite Fest 2027 will be held on Saturday, July 17, 2027 at Grove Elementary School.
          </p>
        </div>
      </section>

      {/* ── ACTIVITIES ── */}
      <section id="activities" className="events" style={{ maxWidth: "var(--max)", marginInline: "auto" }}>
        <div className="sec-hd">
          <span className="sec-eye">What's Happening</span>
          <h2 className="sec-h2">Activities & Events</h2>
          <p className="sec-sub">Something for everyone — come join the fun and support a great cause.</p>
        </div>
        <div className="events__grid">
          {ACTIVITIES.map(act => (
            <div key={act.title} className={`ecard ${act.color}`} style={{ cursor: act.href ? "pointer" : "default" }}>
              <div className="ecard__icon">{act.emoji}</div>
              <div className="ecard__img" style={{
                display: "flex", alignItems: "center", justifyContent: "center",
                background: act.color === "card--purple" ? "var(--pu-200)"
                  : act.color === "card--pink" ? "var(--pk-200)" : "var(--gn-200)",
                fontSize: "4rem",
              }}>
                {act.emoji}
              </div>
              <span className="ecard__label">{act.badge}</span>
              <h3 className="ecard__name">{act.title}</h3>
              <p className="ecard__desc">{act.detail}</p>
              {act.href
                ? <a href={act.href} target="_blank" rel="noopener noreferrer" className="ecard__arrow">{act.cta}</a>
                : <span className="ecard__arrow" style={{ opacity: .5 }}>{act.cta}</span>
              }
            </div>
          ))}
        </div>
      </section>

      {/* ── FLYER ── */}
      <section id="flyer" className="local" style={{ maxWidth: "680px", marginInline: "auto" }}>
        <div className="sec-hd">
          <span className="sec-eye">Official Flyer</span>
          <h2 className="sec-h2">Kite Fest 2027</h2>
        </div>
        <div className="lcard lcard--open" style={{ padding: "1.5rem", alignItems: "center" }}>
          <img
            src="/images/flyers/KiteFest2027.png"
            alt="Kite Fest 2027 Flyer"
            style={{ width: "100%", borderRadius: "12px", display: "block", boxShadow: "0 8px 40px rgba(0,0,0,.1)" }}
          />
        </div>
      </section>

      {/* ── QUOTE BAND ── */}
      <div className="quote-band">
        <p>"Our mission is to promote social justice by meeting needs in the local community and the world through accountable, sustainable philanthropy and by nurturing future generations of servant leaders."</p>
      </div>

    </div>
  );
}